import './apple.css'
import { DiApple } from "react-icons/di";

function AppleLogin(){
    return(
        <div className="cont">
            <>
            <DiApple style={{width:'10%',height:'25px',marginTop:'-5px'}} />
            <p className='cont-text'>Continue to Apple</p>
            </>
        </div>
    )
}
export default AppleLogin;